// React
import * as React from 'react';

//Redux
import { connect } from 'react-redux';

// Router
import { NavLink } from 'react-router-dom';

// MainStore
import { MainStore } from '../stores/MainStore';

// Components
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import DashboardIcon from '@material-ui/icons/Dashboard';
import SubjectIcon from '@material-ui/icons/Subject';
import PhotoAlbumIcon from '@material-ui/icons/PhotoAlbum';
import StoreIcon from '@material-ui/icons/Store';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';

// Functions
import { getURLByEnv } from '../framework/utils/URL';
import { NetworkManager } from '../managers/NetworkManager';
import { getRole, Role } from '../framework/user/Role';

/**
 * @description Props Interface
 * @author Lucas Fridez <lucas@fridez.dev>
 * @interface Props
 */
interface Props {
    navigation: any;
    user: any;
}

/**
 * @description Contain the props of a Menu Child
 * @author Lucas Fridez <lucas@fridez.dev>
 * @interface Menu
 */
interface Menu {
    icon: any;
    link: string;
    title: string;
    roles: Array<Role> | null;
}

/**
 * @description Contain all the menus
 * @author Lucas Fridez <lucas@fridez.dev>
 */
const menus: Array<Menu> = [
    {
        icon: <DashboardIcon />,
        link: `${getURLByEnv()}/`,
        title: "Accueil",
        roles: null
    },
    {
        icon: <PhotoAlbumIcon />,
        link: `${getURLByEnv()}/Realisations`,
        title: "Réalisations",
        roles: null
    },
    // {
    //     icon: <PhotoAlbumIcon />,
    //     link: `${getURLByEnv()}/Galeries`,
    //     title: "Galeries",
    //     roles: null
    // },
    {
        icon: <AccountCircleIcon />,
        link: `${getURLByEnv()}/Equipe`,
        title: "Equipe",
        roles: null
    },
    {
        icon: <StoreIcon />,
        link: `${getURLByEnv()}/Fournisseurs`,
        title: "Fournisseurs",
        roles: null
    },
    {
        icon: <SubjectIcon />,
        link: `${getURLByEnv()}/Articles`,
        title: "Articles",
        roles: null
    }
];

/**
 * @author Lucas Fridez <lucas@fridez.dev>
 * @description Navigation Component
 */
export default connect((state) => state)(class Navigation extends React.Component<Props, {}> {

    /**
     * Creates an instance of Navigation.
     * @author Lucas Fridez <lucas@fridez.dev>
     * @param {*} props
     */
    constructor(props: any) {
        super(props);
    }

    componentWillMount() {
        if (NetworkManager.getUserCredentials() !== undefined) {
            NetworkManager.connect();
        }
    }

    isSubMenuInMenu(menu: string, subMenu: string) {
        if (menu == `${getURLByEnv()}/`) {
            return subMenu == `${getURLByEnv()}/` ? true : false;
        }
        return subMenu.includes(menu.slice(1));
    }

    /**
     * @description Render the Navigation Component
     * @author Lucas Fridez <lucas@fridez.dev>
     * @returns
     */
    render() {
        let userRole: Role = Role.President;
        if(this.props.user.connected && window.sessionStorage.getItem("userCredentials") != null) {
            userRole = getRole( JSON.parse(window.sessionStorage.getItem("userCredentials")|| "{role_id: 0}").role_id);
        }
        return (
            <Drawer
                variant="persistent"
                anchor="left"
                open={this.props.navigation.navigation}
                className={this.props.navigation.navigation ? 'drawer-open' : 'drawer-closed'}>
                <div className="drawerHeader">
                    <IconButton onClick={MainStore.toggleNavigation(this.props.navigation.navigation)}>
                        <ChevronLeftIcon />
                    </IconButton>
                </div>
                <List component="nav">
                    {menus.map((value: Menu, index) => {
                        return ((value.roles == null || (value.roles != null && value.roles.includes(userRole))) &&
                        <NavLink exact={value.title == "Accueil"} to={value.link} activeClassName="menu-active"
                            onClick={MainStore.updateActualView(value.link)} key={index}>
                            <ListItem button={true}>
                                <ListItemIcon>
                                    {value.icon}
                                </ListItemIcon>
                                <ListItemText primary={value.title} />
                            </ListItem>
                        </NavLink>);
                    })}
                </List>
            </Drawer>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/components/Navigation.tsx